'use client'
const isCoinbaseMpcWalletConnector = (connector) => Boolean(connector) &&
    connector.key === 'coinbasempc' &&
    connector.generateWallet !== undefined &&
    connector.changePasscode !== undefined &&
    connector.exportWalletKeys !== undefined;

export { isCoinbaseMpcWalletConnector };
